import { makeStyles } from 'tss-react/mui';

const useStylesImageContainer: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  imageContainer: {
    width: 120,
    height: 120,
    margin: '20px auto',
    padding: 0,
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
    '& img': {
      height: 'auto',
      maxHeight: 120,
      maxWidth: 120,
      verticalAlign: 'middle',
    },
  },
  imageContainerNoOffset: {
    margin: 0,
  },
  imageContainerDisabled: {
    '& img': {
      maxHeight: 100,
      maxWidth: 100,
    },
  },
  imageContainerHelper: {
    display: 'inline-flex',
    verticalAlign: 'middle',
    height: '100%',
  },
}));

export default useStylesImageContainer;
